<template>
  <div class="border-1 border-solid border-grey-divider-subdued rounded-2xl bg-white">
    <button
      class="w-full p-16"
      :aria-expanded="ariaExpanded"
      :class="{ 'cursor-default': !hasAccordionContent }"
      @click="toggleAccordion"
    >
      <div class="flex items-center gap-16 w-full">
        <component :is="icon" :width="16" :height="16" :color="iconColor" />
        <div class="flex flex-col items-start">
          <p class="text-strong-body text-grey-body">{{ label }}</p>
          <p v-if="sublabel" class="text-small text-grey-body text-left">{{ sublabel }}</p>
        </div>
        <expand-icon v-if="hasAccordionContent" color="#4B4C52" :class="expanded && 'rotate-180'" class="ml-auto" />
      </div>
    </button>

    <div v-show="expanded" class="mx-16 mb-16">
      <slot name="accordion-content" />
    </div>
  </div>
</template>

<script lang="ts">
import ExpandIcon from '@/graphics/icons/ExpandIcon.vue';

export default {
  name: 'AccordionRow',
  components: { ExpandIcon },
  props: {
    label: {
      type: String,
      required: true,
    },
    sublabel: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: Object,
      default: null,
    },
    iconColor: {
      type: String,
      default: '#99005c',
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ariaExpanded() {
      return this.expanded ? 'true' : 'false';
    },
    hasAccordionContent() {
      return !!this.$slots['accordion-content'];
    },
  },
  methods: {
    toggleAccordion() {
      if (this.hasAccordionContent) {
        this.expanded = !this.expanded;
      }
    },
  },
};
</script>
